import type { TimelineInternalOps } from '../../timelineInternalOps';
import { isModelVideoTrackBox } from '../../timelineModel';
import type { DeleteBoxAction } from '../timelineActions';


export function deleteBox(timelineInternalHelper: TimelineInternalOps, action: DeleteBoxAction) {
  const box = action.box;

  if (isModelVideoTrackBox(box)) {
    action.undo = timelineInternalHelper.deleteMainTrackBoxes([box]);
  } else {
    action.undo = timelineInternalHelper.deleteSingleTrackBox(box);
  }
}
